export default __webpack_public_path__ + "62b13e325f8720d264b3425d115fe27e.svg";